export const isFalsyParam = (param) =>
  param === 'null' || param === 'undefined' || param === 'NaN';

// True on the internal Game Overview route, the only route that opts into T1
// (pre-snap-only) games. Both GET_GAMES and GET_NAVIGATION key `includeT1Games`
// off this, so the team selector's [X] count matches the games dropdown there
// while every other route keeps the T3-only count.
export const isGameOverviewRoute = (pathname) =>
  Boolean(pathname?.startsWith('/game/overview'));

// True when the teams URL param names a team that is present in the loaded
// navigation list, i.e. the selection can be resolved to a team.
//
// False when the param is missing/falsy, is the '0' placeholder, or names a team
// the current navigation query did not return. That last case is reachable
// because GET_NAVIGATION is route-scoped: Game Overview asks for T1 games, so a
// team whose only games are T1 is listed there and absent from the list on every
// other route. Callers should treat false as "no usable selection" and resolve a
// default team instead of leaving the team details unresolved while the URL
// still points at the missing team.
export const isTeamResolvable = (teamsParam, teams) => {
  if (!teamsParam || isFalsyParam(teamsParam)) return false;

  const teamId = parseInt(teamsParam, 10);
  if (Number.isNaN(teamId) || teamId === 0) return false;

  return (teams || []).some((team) => team?.id === teamId);
};

// True when the games URL param names a game that is actually present in the
// loaded games list, i.e. the selection can be resolved to a game node.
//
// False when the param is missing/falsy, or when it names a game the current
// games query did not return. That second case is reachable because GET_GAMES
// is route-scoped: Game Overview requests `includeT1Games: true`, every other
// route does not, so a T1-only game selected on Overview is absent from the
// list once the user navigates elsewhere. Callers should treat false as "no
// usable selection" and resolve a default game instead of leaving the game
// details unresolved while the URL still points at the missing game.
export const isGameResolvable = (gamesParam, gamesData) => {
  if (!gamesParam || isFalsyParam(gamesParam)) return false;

  const gameId = parseInt(gamesParam, 10);
  if (Number.isNaN(gameId)) return false;

  return (gamesData?.games?.edges || []).some(
    (edge) => edge?.node?.id === gameId,
  );
};
